@if (organizationId(); as oid) {
  <app-organization-sidebar-layout>
    <app-page-header>
      <app-page-title>
        {{ 'cockpit.documents.page.title' | transloco }}
      </app-page-title>

      <ui-button mode="outlined" slot="end" (click)="uploadDialog.showModal()" disableInDemoMode>
        <ng-icon name="heroCloudArrowUp" size="20" slot="start" class="!block" />
        {{ 'cockpit.documents.page.uploadButton' | transloco }}
      </ui-button>
    </app-page-header>

    <div slot="sticky-header">
      @if (selectedRows().length) {
        <div class="flex gap-3 items-center">
          <span class="flex-1">
            {{
              'cockpit.documents.page.selectedCount' | transloco: { count: selectedRows().length }
            }}
          </span>
          <ui-button mode="outlined" (click)="onClickDeleteDocuments()" disableInDemoMode>
            <span class="text-error dark:text-error-darkmode" slot="start">
              <ng-icon name="heroTrash" size="20" class="!block" />
            </span>
            <span class="text-error dark:text-error-darkmode">
              {{
                'cockpit.documents.page.deleteSelectedButton'
                  | transloco: { count: selectedRows().length }
              }}
            </span>
          </ui-button>
        </div>
      } @else {
        <app-documents-filter-form (changeFilter)="onChangeFilter()" />
      }
    </div>

    @if (!documents()[0]?.isLoading && total() === 0 && isInitialFilterActive()) {
      <app-documents-empty-box (clickUpload)="uploadDialog.showModal()" />
    } @else if (!documents()[0]?.isLoading && total() === 0) {
      <app-documents-filter-no-results />
    } @else {
      <app-documents-table
        #table
        [documents]="documents()"
        [organizationId]="oid"
        [showLoadMorePlaceholders]="showLoadMorePlaceholders()"
        [limit]="limit()"
        [orderBy]="orderBy()"
        [orderDirection]="orderDirection()"
        (changeOrder)="onChangeOrder($event)"
        (deleteDocuments)="onDeleteDocuments($event)"
        appInfiniteScroll
        (nearEnd)="onLoadMore()"
        (scrollWindow)="table.dismissContextMenus()"
      />
    }
  </app-organization-sidebar-layout>

  <ui-simple-dialog #uploadDialog [lazy]="true">
    @if (organizationId(); as oid) {
      <app-document-upload-dialog
        class="w-full"
        [organizationID]="oid"
        (clickCancel)="uploadDialog.close()"
        (uploadSuccess)="onUploadDialogSuccess(uploadDialog)"
      />
    }
  </ui-simple-dialog>
}

<app-tutorial-documents-popover />
